module.exports = __webpack_public_path__ + "img/Group1142815672.d4ad86cf.png";